import React, { useEffect, useRef, useCallback, useState } from "react";
import Logo from "../assets/images/logo_3x.png";
import { useDispatch, useSelector } from "react-redux";
import { PrivateRoutes } from "../routes/routes";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Menu } from "primereact/menu";
import { getActiveRoute } from "../utils/commonFunctions";
import { ReactComponent as MenuIcon } from "../assets/images/svg/menu.svg";

export default function Sidebar({ setActiveRoute, mobileMenu, setMobileMenu }) {
  const [isFullSidebar, setIsFullSidebar] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    let path = location.pathname;
    let activeRoute = getActiveRoute(PrivateRoutes, path);
    setActiveRoute(activeRoute);
    setMobileMenu(false);
  }, [location, setActiveRoute, setMobileMenu]);

  return (
    <div
      className={`shadow-3 z-5 sidebar ${!isFullSidebar ? "icon-sidebar" : ""
        } ${mobileMenu ? "mobile-menu" : ""}`}
    >
      <div className="relative">
        <div className="sidebar-logo p-3">
          <img src={Logo} alt="PandaStack Logo" className="cursor-pointer" onClick={() => navigate("/")} />
          {/* <span className="text-medium text-xl cursor-pointer" onClick={()=> navigate("/")}>PandaStack</span> */}
          <span className="text-medium text-xl cursor-pointer" >PandaStack</span>
          <MenuIcon className="toggle-icon" onClick={() => setIsFullSidebar((prev) => !prev)} />
        </div>
        {/* <i
          className={`pi pi-chevron-left absolute toggle-icon`}
          onClick={() => setIsFullSidebar((prev) => !prev)}
        /> */}
        <i
          className={`pi pi-times menu-close-icon absolute top-1rem md:hidden block`}
          onClick={() => setMobileMenu(false)}
        />
      </div>
      <div className="nav-links">
        {PrivateRoutes.filter((route) => !route.hideFromNav).map(
          (route, index) => {
            return (
              <div className="nav-link" key={index}>
                <div
                  className={`link-div ${route?.subMenu ? "mt-2" : "my-2"}`}

                >
                  <div className="px-3">
                    <NavLink
                      to={route.path}
                      className={`flex w-full p-2 pl-3 align-items-center gap-2 no-underline`}
                    >
                      <i className={`${route.icon} text-xl`} />
                      <div className="inline-flex w-full justify-content-between align-items-center">
                        <span>{route.name}</span>
                        {route?.subMenu && <i className="pi pi-chevron-down ml-3" />}
                      </div>
                    </NavLink>
                  </div>
                </div>
                {route?.subMenu &&
                  route?.subMenu?.map((menu, i) => (
                    <div className="sub-menu pr-2 pl-4">
                      <NavLink
                        to={menu.path}
                        key={i}
                        className="flex w-full text-sm p-2 border-left-2 border-gray-300 align-items-center gap-2 no-underline"
                      >
                        <i className={`${menu.icon} text-sm`} />
                        <span>{menu.name}</span>
                      </NavLink>
                    </div>
                  ))}
              </div>
            );
          }
        )}
      </div>
    </div>
  );
}
